import _ from 'underscore';

export default class UserProfile {
  public static userProfileFromAPI(user: any): UserProfile {
    const userProfile: UserProfile = new UserProfile();
    userProfile.setAllFields(user);
    return userProfile;
  }

  public id?: number;
  public securityLevel?: string;
  public emailAddress?: string;
  public ubcId?: string;
  public firstName?: string;
  public middleName?: string;
  public lastName?: string;
  public suffix?: string;
  public affiliateId?: number;
  public title?: string;
  public workPhoneNumber?: number;
  public workPhoneNumberExt?: number;
  public cellPhoneNumber?: number;
  public faxNumber?: number;
  public emergencyContactName?: string;
  public emergencyContactRelationship?: string;
  public emergencyContactDayPhoneNumber?: string;
  public emergencyContactDayPhoneNumberExt?: string;
  public emergencyContactNightPhoneNumber?: string;
  public emergencyContactNightPhoneNumberExt?: string;
  public jobCorpsCenterIds?: number[];
  public jobCorpsCenterPrimaryId?: number;
  public address1?: string;
  public address2?: string;
  public city?: string;
  public state?: string;
  public zip?: string;
  public country?: string;
  public county?: string;
  public active?: boolean;
  public lastLogin?: Date;
  public passwordExpired: boolean = true;
  public override: boolean = false;
  public reactivated?: Date;
  public reactivatedByUserId?: number;
  public deactivated?: Date;
  public deactivatedByUserId?: number;

  public getFullName(): string {
    return `${this.firstName || ''}${!!this.middleName ? ' ' + this.middleName : ''} ${this.lastName || ''}${!!this.suffix ? ' ' + this.suffix : ''}`;
  }

  public getFullNameLastNameFirst(): string {
    const nameString = `${this.lastName ? this.lastName : ''}, ` + `${this.firstName ? this.firstName + ' ' : ''}`;
    return nameString;
  }

  protected setAllFields(user: any) {
    this.id = user.id;
    this.securityLevel = user.securityLevel;
    this.emailAddress = user.emailAddress;
    this.ubcId = user.ubcId;
    this.firstName = user.firstName;
    this.middleName = user.middleName;
    this.lastName = user.lastName;
    this.suffix = user.suffix;
    this.affiliateId = user.affiliateId;
    this.title = user.title;
    this.workPhoneNumber = user.workPhoneNumber;
    this.workPhoneNumberExt = user.workPhoneNumberExt;
    this.cellPhoneNumber = user.cellPhoneNumber;
    this.faxNumber = user.faxNumber;
    this.emergencyContactName = user.emergencyContactName;
    this.emergencyContactRelationship = user.emergencyContactRelationship;
    this.emergencyContactDayPhoneNumber = user.emergencyContactDayPhoneNumber;
    this.emergencyContactDayPhoneNumberExt = user.emergencyContactDayPhoneNumberExt;
    this.emergencyContactNightPhoneNumber = user.emergencyContactNightPhoneNumber;
    this.emergencyContactNightPhoneNumberExt = user.emergencyContactNightPhoneNumberExt;
    this.address1 = user.address1;
    this.address2 = user.address2;
    this.city = user.city;
    this.state = user.state;
    this.zip = user.zip;
    this.country = user.country;
    this.county = user.county;
    this.active = user.active;
    this.jobCorpsCenterIds = _(user.jobCorpsCenterIds).isArray() ? user.jobCorpsCenterIds : [];

    const jcId = parseInt(user.jobCorpsCenterPrimaryId as string, 10) || 0;
    this.jobCorpsCenterPrimaryId = 0 < jcId ? jcId : undefined;

    this.lastLogin = user.lastLogin;
    this.passwordExpired = true === user.passwordExpired;
    this.override = true === user.override;
    this.reactivated = user.reactivated;
    this.reactivatedByUserId = user.reactivatedByUserId;
    this.deactivated = user.deactivated;
    this.deactivatedByUserId = user.deactivatedByUserId;
  }
}
